import React, { useEffect } from 'react'
import founderImg from '../assets/founder.jpg'
import buildingImg from '../assets/building.jpg'

export default function About() {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <main className="min-h-screen bg-white text-gray-900 pb-24">
            {/* Minimal Hero with slight primary tint */}
            <section className="pt-32 pb-24 px-6 max-w-4xl mx-auto text-center">
                <span className="text-xs tracking-widest uppercase text-secondary mb-6 block font-semibold">The Foundation Odyssey</span>
                <h1 className="text-4xl md:text-6xl font-light text-primary tracking-tight leading-tight mb-8">
                    Our <span className="font-medium text-secondary">Chronicle</span>.
                </h1>
                <p className="text-lg md:text-xl text-gray-500 font-light max-w-2xl mx-auto leading-relaxed">
                    A profound commitment to building a stronger community through the harmonious blend of education, technology, and pure humanity.
                </p>
            </section>

            {/* Content Split */}
            <section className="py-24 px-6 md:px-12 max-w-7xl mx-auto flex flex-col lg:flex-row gap-16 lg:gap-24 items-center border-t border-gray-100">
                <div className="w-full lg:w-1/2 aspect-square bg-primary/5 rounded-[40px] overflow-hidden">
                    <img loading="lazy" src={buildingImg} alt="Headquarters" className="w-full h-full object-cover opacity-90 transition-opacity hover:opacity-100 duration-500" />
                </div>
                <div className="w-full lg:w-1/2 flex flex-col">
                    <span className="text-xs uppercase tracking-widest text-secondary mb-6 font-semibold">Who We Are</span>
                    <h2 className="text-3xl md:text-5xl font-light text-primary mb-8 leading-tight">
                        Faiz ul Hasnain Foundation
                    </h2>
                    <p className="text-gray-600 leading-relaxed font-light mb-6 border-l-4 border-secondary/60 pl-4 bg-primary/5 p-4 rounded-r-2xl">
                        Ek non-profit social platform hai jo taleem, technology, tijarat, aqeeda aur hifazat ke zariye community ko behtar aur mustahkam banane ka mission rakhta hai. Hamara maqsad har fard ko wo saare zariye faraham karna hai jisse woh apne mustaqbil ko roshan bana sake — chahe woh taleem ho, skill development ho, ya insani khidmat.
                    </p>
                    <p className="text-gray-600 leading-relaxed font-light mb-8">
                        Foundation ke zariye computer classes, digital marketing, technical courses, work-from-home training, online learning, free dispensary, gareebon ki madad, tree plantation, safai muhimmat, aur aurton ki hifazat jaise kai aham projects chalaye ja rahe hain. Hamare har project ki bunyad ilm, akhlaq aur positivity ko society tak pohanchana hai.
                    </p>

                    <div className="mb-8 p-6 bg-white border border-gray-100 rounded-3xl shadow-sm hover:border-secondary/30 transition-colors">
                        <span className="text-xs uppercase tracking-widest text-secondary font-semibold mb-2 block">Hamara Mission — Hamari Pehchaan</span>
                        <h4 className="text-xl text-primary font-medium italic mb-3">"Nafrat Kisi Se Nahin, Mohabbat Sabke Liye"</h4>
                        <p className="text-sm text-gray-500 font-light leading-relaxed">
                            Ye sirf hamara slogan nahi, balki hamari soch, hamari neeyat aur hamara kaam hai. Hum ek aisi society banana chahte hain jahan log ek dusre ke liye pyaar, izzat aur madad ka jazba rakhte hon.
                        </p>
                    </div>

                    <p className="text-gray-600 leading-relaxed font-light mb-12 bg-gray-50 p-6 rounded-2xl border border-gray-100">
                        <strong className="text-primary font-medium block mb-2">Hamara Vision</strong>
                        Faiz ul Hasnain Foundation ka vision ye hai ke har insaan ko izzat, ilm, mohabbat aur mauqa mile — aur hamari community taraqqi, tehzeeb aur insaniyat ki roshni se chamakti rahe.
                    </p>
                    <div className="flex gap-12 pt-8 border-t border-gray-100">
                        <div>
                            <span className="text-3xl font-light text-primary block mb-2">5+</span>
                            <span className="text-xs text-secondary uppercase tracking-widest font-semibold">Years Legacy</span>
                        </div>
                        <div>
                            <span className="text-3xl font-light text-primary block mb-2">5</span>
                            <span className="text-xs text-secondary uppercase tracking-widest font-semibold">Core Pillars</span>
                        </div>
                    </div>
                </div>
            </section>

            {/* Founder Section */}
            <section className="py-24 px-6 md:px-12 max-w-7xl mx-auto flex flex-col lg:flex-row-reverse gap-16 lg:gap-24 items-center">
                <div className="w-full lg:w-2/5 aspect-[3/4] bg-primary/5 rounded-[40px] overflow-hidden">
                    <img loading="lazy" src={founderImg} alt="Sibtain Raza Ashrafi" className="w-full h-full object-cover opacity-90 transition-opacity hover:opacity-100 duration-500" />
                </div>
                <div className="w-full lg:w-3/5 flex flex-col">
                    <span className="text-xs uppercase tracking-widest text-secondary font-semibold mb-6">Leadership</span>
                    <h2 className="text-3xl md:text-5xl font-light text-primary mb-8 leading-tight">
                        The Architect of Change.
                    </h2>
                    <div className="space-y-6 text-gray-600 font-light leading-relaxed">
                        <p>
                            Originally from the historic city of Prayagraj (Allahabad), Sibtain Raza Ashrafi is a vision-driven leader who has dedicated his journey to community development.
                        </p>
                        <p>
                            Under his stewardship, the Faiz-ul-Hasnain Foundation has become a symbol of sincerity and professional excellence, integrating technology, commerce, faith, and protection into a unified developmental system.
                        </p>
                        <blockquote className="border-l-4 border-secondary bg-primary/5 p-6 mt-8 italic text-primary rounded-r-2xl">
                            "His ultimate vision is a future where every member of the community is empowered with the light of knowledge, the edge of technology, and the strength of character."
                        </blockquote>
                    </div>
                </div>
            </section>

            {/* Core Pillars */}
            <section className="py-24 px-6 md:px-12 max-w-7xl mx-auto border-t border-gray-100 text-center">
                <h2 className="text-3xl font-light text-primary mb-16">The Five Pillars</h2>
                <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
                    {[
                        { name: "Aqeeda", eng: "Faith", desc: "Spiritual roots" },
                        { name: "Taleem", eng: "Education", desc: "Igniting minds" },
                        { name: "Technology", eng: "Digital Future", desc: "Bridging modern gaps" },
                        { name: "Tijarat", eng: "Business", desc: "Economic growth" },
                        { name: "Hifazat", eng: "Protection", desc: "Community safety" }
                    ].map((pillar, i) => (
                        <div key={i} className="flex flex-col items-center p-6 bg-white border border-gray-50 rounded-3xl shadow-sm hover:border-secondary/30 transition-colors">
                            <span className="text-xl font-medium text-primary mb-2 line-clamp-1">{pillar.name}</span>
                            <span className="text-[10px] text-secondary uppercase tracking-[3px] mb-4 block font-semibold text-center">{pillar.eng}</span>
                            <p className="text-sm text-gray-500 font-light text-center">{pillar.desc}</p>
                        </div>
                    ))}
                </div>
            </section>
        </main>
    )
}
